import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Edit from '@material-ui/icons/Edit'
import Map from "@material-ui/icons/Map";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import {Tooltip} from "@material-ui/core";
import moment from "moment";
import 'react-confirm-alert/src/react-confirm-alert.css';
import {
	ensureNonHiringRegionAcknowledged,
	fetchHiringRegions,
} from "components/utils/hiringRegions";

export default class Candidates extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Hiring_Candidate._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
		this.state.hiringRegions = [];
		// Scheduled Interview view defaults to sorting by interview date, newest first.
		if (props.filter === 4) {
			this.model.sort = 'interview_date';
			this.model.order = 'desc';
		}
	}

	async componentDidMount() {
		super.componentDidMount();
		try {
			const hiringRegions = await fetchHiringRegions();
			this.setState({hiringRegions});
		} catch (error) {
		}
	}

	handlePromoteCandidate = async (candidate) => {
		const canPromote = await ensureNonHiringRegionAcknowledged({
			regionPkey: candidate.region,
			hiringRegions: this.state.hiringRegions,
			regionObject: candidate.regions,
			context: 'promote',
		});
		if (!canPromote) {
			return;
		}

		let candModel = new API.BuildClass(Types.Hiring_Candidate._name, API.RequestType.READ_ALL);
		candModel.object.pkey = candidate.pkey;
		await candModel.submit(null, 'POST_PROMOTE');
		await this.fetchData();
	}

	returnRoute = (status) => {
		let returnable = '';
		switch (status) {
			case 2:
				returnable = 'reach_out';
				break;

			case 3:
				returnable = 'pre_interview';
				break;

			case 4:
				returnable = 'scheduled_interview';
				break;

			case 5:
			case 6:
			case 7:
			case 8:
			case 9:
				returnable = 'interviews';
				break;

			case 10:
				returnable = 'offered_job';
				break;

			case 11:
				returnable = 'paperwork';
				break;
			case 12:
				returnable = 'hired';
				break;
			case 13:
				returnable = 'actively';
				break;
			case 14:
				returnable = 'declined';
				break;
			case 15:
				returnable = 'quit';
				break;
			case 16:
				returnable = 'hold';
				break;
		}
		return returnable;
	}

	async componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevState.search !== this.state.search) {
			if (this.timeout) clearTimeout(this.timeout);
			this.timeout = setTimeout(async () => {
				//search function
				await this.fetchData();
			}, 100);
		}
		if (prevProps.filter !== this.props.filter) {
			this.setState({pages: null, search: ''})
		}
	}

	fetchData = async (state) => {
		if (this.props.tableData) {
			this.setState({data: this.props.tableData, pages: 1, limit: this.props.tableData.length})
			return;
		}
		this.state.filter = {};
		if (this.props.filter) {
			this.state.filter.status = this.props.filter
		}
		this.setState({loading: true});
		window.setTimeout(() => {
			this.fetchDataActual(state);
		}, 100);
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const extraColumns = this.props.filter === 4 ? [{
			Header: "Interview Date",
			id: "interview_date",
			/** @param {Hiring_Candidate_Object} obj */
			accessor: obj => (obj.interview_date?.length === 0 || !obj.interview_date ? "N/A" : moment(obj.interview_date).format("YYYY-MM-DD h:mm A"))
		}] : this.props.filter === 5 ? [{
			Header: "Interview Step",
			id: "interview",
			/** @param {Hiring_Candidate_Object} obj */
			accessor: obj => (obj.candidate_statuses?.name ?? 'N/A')
		}, {
			Header: "Rating",
			id: "rating",
			/** @param {Hiring_Candidate_Object} obj */
			accessor: obj => (obj.rating ? obj.rating + '/10' : 'N/A')
		}] : this.props.filter === 12 || this.props.filter === 13 ? [{
			Header: "Start Date",
			id: "start_date",
			/** @param {Hiring_Candidate_Object} obj */
			accessor: obj => (obj.start_date?.length === 0 || !obj.start_date ? "N/A" : moment(obj.start_date).format("YYYY-MM-DD"))
		}] : (this.props.filter >= 3 && this.props.filter <= 9) || this.props.filter === 16 ? [{
				Header: "Rating",
				id: "rating",
				/** @param {Hiring_Candidate_Object} obj */
				accessor: obj => (obj.rating ? obj.rating + '/10' : 'N/A')
			}]
		: [];
		const columns = this.props.filter === 'search' ? [
			{
				Header: "First Name",
				id: "name_first",
				/** @param {Hiring_Candidate_Object} obj */
				Cell: props => {
					return (
						<span>
							<Link to={`/hiring/candidates/${props.original.pkey}`}>
								{props.original.name_first}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "Last Name",
				id: "name_last",
				/** @param {Hiring_Candidate_Object} obj */
				Cell: props => {
					return (
						<span>
							<Link to={`/hiring/candidates/${props.original.pkey}`}>
								{props.original.name_last}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "Metro",
				id: "metro",
				/** @param {Hiring_Candidate_Object} obj */
				accessor: obj => (obj.regions?.name ?? 'N/A')
			},
			{
				Header: "Status",
				id: "status",
				/** @param {Hiring_Candidate_Object} obj */
				Cell: props => {
					return (
						<span>
							<Link to={"/hiring/" + this.returnRoute(props.original.candidate_status)}>
								{props.original.candidate_statuses?.name}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "Status Changed On",
				id: "status_changed_on",
				/** @param {Hiring_Candidate_Object} obj */
				accessor: obj => (obj.status_changed_on?.length === 0 || !obj.status_changed_on ? "N/A" : moment(obj.status_changed_on).format("YYYY-MM-DD h:mm A"))
			},
		] : this.props.tableData ? [
			{
				Header: "First Name",
				id: "name_first",
				/** @param {Hiring_Candidate_Object} obj */
				Cell: props => {
					return (
						<span>
							<Link to={`/hiring/candidates/${props.original.pkey}`}>
								{props.original.name_first}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "Last Name",
				id: "name_last",
				/** @param {Hiring_Candidate_Object} obj */
				Cell: props => {
					return (
						<span>
							<Link to={`/hiring/candidates/${props.original.pkey}`}>
								{props.original.name_last}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "Phone",
				id: "phone",
				/** @param {Hiring_Candidate_Object} obj */
				accessor: obj => (obj.phone)
			},
			{
				Header: "Email",
				id: "email",
				/** @param {Hiring_Candidate_Object} obj */
				accessor: obj => (obj.email)
			},
			{
				Header: "Metro",
				id: "metro",
				/** @param {Hiring_Candidate_Object} obj */
				accessor: obj => (obj.regions?.name ?? 'N/A')
			},
			{
				Header: "Status",
				id: "status",
				/** @param {Hiring_Candidate_Object} obj */
				accessor: obj => (obj.candidate_statuses?.name)
			},
			{
				Header: "Status Changed On",
				id: "status_changed_on",
				/** @param {Hiring_Candidate_Object} obj */
				accessor: obj => (obj.status_changed_on?.length === 0 || !obj.status_changed_on ? "N/A" : moment(obj.status_changed_on).format("YYYY-MM-DD h:mm A"))
			},
		] : [
			{
				Header: "First Name",
				id: "name_first",
				/** @param {Hiring_Candidate_Object} obj */
				Cell: props => {
					return (
						<span>
							<Link to={`/hiring/candidates/${props.original.pkey}`}>
								{props.original.name_first}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "Last Name",
				id: "name_last",
				/** @param {Hiring_Candidate_Object} obj */
				Cell: props => {
					return (
						<span>
							<Link to={`/hiring/candidates/${props.original.pkey}`}>
								{props.original.name_last}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "Address",
				id: "full_address",
				/** @param {Hiring_Candidate_Object} obj */
				accessor: obj => (obj.full_address ?? (obj.city !== "" || obj.street_1 !== "" || obj.state !== "" || obj.zip !== "") ? [obj.street_1, obj.city, obj.state, obj.zip].filter(Boolean).join(", ") : 'N/A')
			},
			{
				Header: "Metro",
				id: "metro",
				/** @param {Hiring_Candidate_Object} obj */
				accessor: obj => (obj.regions?.name ?? 'N/A')
			},
			...extraColumns,
			{
				Header: "Status Changed On",
				id: "status_changed_on",
				/** @param {Hiring_Candidate_Object} obj */
				accessor: obj => (obj.status_changed_on?.length === 0 || !obj.status_changed_on ? "N/A" : moment(obj.status_changed_on).format("YYYY-MM-DD h:mm A"))
			},
			{
				Header: "",
				id: "map",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				/** @param {Hiring_Candidate_Object} obj */
				accessor: obj => obj.name,
				Cell: props => {
					if ((parseFloat(props.original.latitude) !== 0 && parseFloat(props.original.longitude) !== 0)) {
						if (props.original.region) {
							return (
								<span>
									<Tooltip title={'Send to Map'}>
										<Button color="info" size={"sm"} block={true} onClick={() => {
											localStorage.setItem('map_coords', props.original.latitude + ',' + props.original.longitude + ',' + props.original.region)
										}}>
											<Link to={"/hiring/heatmap/"} target={"_blank"}>
												<Map fontSize={'small'}/>
											</Link>
										</Button>
									</Tooltip>
								</span>
							)
						} else {
							return (
								<span>
									<Tooltip title={'This candidate has no region. Please fix their address.'}>
										<Button color="info" size={"sm"} block={true} disabled={true}>
											<Map fontSize={'small'}/>
										</Button>
									</Tooltip>
								</span>
							)
						}
					} else {
						return null;
					}
				}
			},
			{
				Header: "",
				id: "promote",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				/** @param {Hiring_Candidate_Object} obj */
				accessor: obj => obj.name,
				Cell: props => {
					return (
						<span>
							{this.props.filter < 13 && <Tooltip title={'Promote to Next Status'}>
								<Button color="warning" size={"sm"} block={true} onClick={() => {
									this.handlePromoteCandidate(props.original);
								}}>
									<ArrowUpward fontSize={'small'}/></Button>
							</Tooltip>}
						</span>
					);
				}
			},
			{
				Header: "",
				id: "edit",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				/** @param {Hiring_Candidate_Object} obj */
				accessor: obj => obj.name,
				Cell: props => {
					return (
						<span data-cy={`edit-${props.original.name}`}>
							<Link to={"/hiring/candidates/" + props.original.pkey}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<Edit fontSize={'small'}/></Button>
							</Link>
						</span>
					);
				}
			},
		]
		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						{!this.props.tableData && <div className="d-flex">
							{this.renderSearch('Candidates')}
							{this.renderHeaderRight("Candidates", columns)}
						</div>}
					</div>
					<ReactTable
						key={this.state.key + this.props.filter}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
